<template>
    <div>
        <b-row class="pb-2 mb-md-3">
            <b-col md="4">
                <b-form-file browse-text="بارگذاری" v-model="categoryIcon" @change="createCategoryIcon"
                    :disabled="loadingForm" placeholder="" />
                <div class="position-absolute d-flex align-items-center" style="z-index: 1;left: 85px;">
                    <b-spinner v-if="loading" variant="primary" small></b-spinner>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col v-for="(item, index) in categoryIconList" :key="index" cols="4" xl="2" lg="2" md="2" sm="3"
                class="mb-2 pb-50">
                <div class="d-flex justify-content-center">
                    <div class="position-relative" style="height: 95px;width: 95px;">
                        <div @click="deleteCategoryIcon(item.id)"
                            class="position-absolute pointer bg-primary rounded-circle p-25"
                            style="left: -6px;top: -8px;">
                            <feather-icon size="20" icon="XIcon" class="text-white" />
                        </div>
                        <div class="border-info p-25 rounded w-100 h-100">
                            <img :src="BASE_URL_File + item.icon" class="w-100 h-100 object-fit-cover">
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { BCard, BCardText, BLink, BRow, BCol, BButton, BImg, BAvatar, BTable, BFormFile, BSpinner } from 'bootstrap-vue';
import { adminService } from '@core/services';

export default {
    components: {
        BCard,
        BCardText,
        BLink,
        BRow,
        BCol,
        BButton,
        BImg,
        BAvatar,
        BTable,
        BFormFile,
        BSpinner
    },
    data() {
        return {
            loading: true,
            loadingForm: false,
            BASE_URL_File: process.env.VUE_APP_BASE_URL_File,
            parameters: {
                pageIndex: 1,
                pageSize: 99,
                totalCount: null,

            },
            categoryIconList: [],
            categoryIcon: null
        }
    },
    methods: {
        getCategoryIcon() {
            adminService.getCategoryIcon(this.parameters).then(({ data }) => {
                this.parameters.totalCount = data.totalCount
                this.categoryIconList = data.items
                this.loading = false
            })
        },
        deleteCategoryIcon(id) {
            adminService.deleteCategoryIcon({ id: id }).then(({ data }) => {
                this.categoryIconList = this.categoryIconList.filter(value => value.id !== id);
                this.$notif({ type: 'success' });
            })
        },
        createCategoryIcon(event) {
            this.loadingForm = true;
            const file = event.target.files[0];
            let formData = new FormData();
            formData.append("IconFile", file)
            adminService.createCategoryIcon(formData).then(({ data }) => {
                this.categoryIconList.unshift({
                    id: data.id,
                    icon: data.icon
                });
                this.$notif({ type: 'success' });
                this.loadingForm = false;
                this.categoryIcon = null;
            })

                .catch(() => {
                    this.$notif({ type: 'error' });
                    this.loadingForm = false;
                    this.categoryIcon = null;
                });
        },
    },
    mounted() {
        this.getCategoryIcon()
    },
};
</script>